import { Controller } from "react-hook-form";

const VALID_PATTERN = /^\d{0,12}(\.\d{0,2})?$/;

export default function InlineCurrencyInput({
  name,
  control,
  rules,
  className = "text-2xl",
}) {
  const mergedRules = rules || {};

  return (
    <Controller
      name={name}
      control={control}
      rules={mergedRules}
      render={({ field: { ref, onChange, onBlur, ...field } }) => (
        <span
          className={`font-semibold text-zinc-900 inline-flex items-baseline ${className}`}
        >
          £
          <span className="relative inline-block">
            <span
              className={`invisible whitespace-pre font-semibold ${className}`}
              aria-hidden="true"
            >
              {field.value || "0.00"}
            </span>
            <input
              {...field}
              ref={ref}
              type="text"
              inputMode="decimal"
              placeholder="0.00"
              className={`absolute inset-0 bg-transparent border-none outline-none font-semibold text-zinc-900 w-full p-0 m-0 placeholder-zinc-300 ${className}`}
              onKeyDown={(e) => {
                const allowed =
                  /^\d$/.test(e.key) ||
                  e.key === "." ||
                  e.key === "Backspace" ||
                  e.key === "Delete" ||
                  e.key === "ArrowLeft" ||
                  e.key === "ArrowRight" ||
                  e.key === "Tab" ||
                  e.key === "Home" ||
                  e.key === "End" ||
                  e.metaKey ||
                  e.ctrlKey;
                if (!allowed) e.preventDefault();
              }}
              onChange={(e) => {
                const raw = e.target.value;
                if (raw === "" || VALID_PATTERN.test(raw)) {
                  onChange(raw);
                }
              }}
              onBlur={(e) => {
                const raw = e.target.value;
                const num = parseFloat(raw);
                const formatted = Number.isFinite(num) ? num.toFixed(2) : "";
                onChange(formatted);
                onBlur();
              }}
            />
          </span>
        </span>
      )}
    />
  );
}
